import React from 'react';
import FilterCategory from './filterCategory';
import { MultiOptionCategory } from '../types';
import { toggleChoice } from '../filterListSlice';
import { useDispatch } from 'react-redux';

interface CalendarFilterProps {
  category: MultiOptionCategory;
  index: number;
}

const CalendarFilter = ({ category, index }: CalendarFilterProps) => {
  const dispatch = useDispatch();

  const handleMonthToggle = (
    category: number,
    option: number,
    disabled: boolean,
  ) => {
    if (!disabled) {
      dispatch(toggleChoice({ categoryIndex: category, optionIndex: option }));
    }
  };

  return category ? (
    <FilterCategory
      icon={category.icon}
      name={category.name}
      index={index}
      closed={category.closed}
    >
      <div className='tour__filter__body'>
        <div className='container'>
          <div className='row tour__filter__month'>
            {category.options.map((month, i) => {
              let monthClass = 'tour__filter__month__option';

              if (month.disabled) {
                monthClass = `${monthClass} tour__filter__month__option--disabled`;
              } else if (month.selected) {
                monthClass = `${monthClass} tour__filter__month__option--active`;
              }

              return (
                <div
                  className='col-3 p-0'
                  key={`monthitem_${month.id}_${i}`}
                  onClick={() => handleMonthToggle(index, i, month.disabled)}
                  aria-disabled={month.disabled}
                >
                  <div className={monthClass}>{month.name}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </FilterCategory>
  ) : null;
};

export default CalendarFilter;
